import { useState, useContext, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Typography,
  Grid,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Navigation from "./Navigation";
import HeaderLogo from "../assets/headerLogo.png";
import ROUTES from "../data/headerRoutes";
import useStyles from "../styles/components/HeaderStyles";
import UserSVGR from "../smart-assets/SVGRs/UserSVGR";
import LogoutSVGR from "../smart-assets/SVGRs/LogoutSVGR";
import LoginModal from "./Modals/LoginModal";
import { UserContext } from "../contexts/UserContext";
import classNames from "classnames";
import useLanguage from "../hooks/useLanguage";
import ChangeLanguage from "../components/ChangeLanguage";

const Header = (props) => {
  const classes = useStyles(props);
  const history = useHistory();

  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const { user, logout } = useContext(UserContext);

  const {
    globalComponents: { header: STRINGS },
  } = useLanguage();

  const openUserMenu = useCallback((e) => {
    setAnchorEl(e.currentTarget);
  }, []);

  const closeUserMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const goToAccount = useCallback(() => {
    closeUserMenu();
    history.push("/account");
  }, [closeUserMenu, history]);

  const handleLogout = useCallback(() => {
    closeUserMenu();
    logout();
  }, [closeUserMenu, logout]);

  const initials = `${user?.name?.[0] ?? ""}${user?.last_name?.[0] ?? ""}`;

  return (
    <AppBar id="header" position="static" className={classes.headerStyles}>
      <Grid container item className={classes.containerGrid}>
        <Toolbar
          classes={{ gutters: classes.gutterStyles }}
          className={classes.toolBarStyles}
        >
          <Grid
            item
            container
            xs={10}
            sm={1}
            className={classes.mobileTopPartContainerWrapper}
          >
            <Box className={classes.mobileTopPartContainer}>
              <img
                onClick={() => history.push(`/`)}
                src={HeaderLogo}
                className={classes.logo}
                alt="LeaderCard"
              />

              <Box className={classes.buttonAndChangeLanguage}>
                <Box className={classes.changeLanguageContainer2}>
                  <ChangeLanguage />
                </Box>
                {user ? (
                  <Box
                    className={classNames(
                      classes.userLFNames,
                      classes.userLFNamesMobile,
                    )}
                    onClick={openUserMenu}
                    role="button"
                    tabIndex={0}
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      variant="body1"
                      className={classes.userLFNamesText}
                    >
                      {initials}
                    </Typography>
                  </Box>
                ) : (
                  <UserSVGR
                    onClick={() => setLoginModalOpen(true)}
                    className={classes.UserSVGR}
                  />
                )}
              </Box>
            </Box>
          </Grid>

          <Box className={classes.boxStyles}>
            <Navigation routes={ROUTES} STRINGS={STRINGS.navigation} />

            {user ? (
              <>
                <Box className={classes.changeLanguageContainer}>
                  <ChangeLanguage />
                </Box>
                <Box
                  className={classes.userLFNames}
                  onClick={openUserMenu}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: "pointer" }}
                >
                  <Typography
                    variant="body1"
                    className={classes.userLFNamesText}
                  >
                    {initials}
                  </Typography>
                </Box>
              </>
            ) : (
              <Box className={classes.changeLanguageContainer}>
                <Button
                  id="login-button"
                  onClick={() => setLoginModalOpen(true)}
                  className={classes.buttonStyles}
                >
                  {STRINGS.loginButton}
                </Button>
                <ChangeLanguage />
              </Box>
            )}
          </Box>

          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={closeUserMenu}
            keepMounted
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            classes={{ paper: classes.menuPaper, list: classes.menuList }}
            PopoverClasses={{ root: classes.menuPopover }}
          >
            <MenuItem className={classes.menuHeaderItem}>
              {`${user?.name ?? ""} ${user?.last_name ?? ""}`}
            </MenuItem>

            <MenuItem onClick={goToAccount} className={classes.menuItem}>
              {STRINGS?.navigation?.account ?? "My account"}
            </MenuItem>

            <MenuItem onClick={handleLogout} className={classes.menuItem}>
              <div className={classes.menuItemRow}>
                <span className={classes.menuItemText}>
                  {STRINGS?.logout ?? "Logout"}
                </span>

                <LogoutSVGR className={classes.menuItemIcon} />
              </div>
            </MenuItem>
          </Menu>
        </Toolbar>
      </Grid>

      <LoginModal
        isOpen={loginModalOpen}
        onClose={() => setLoginModalOpen(false)}
      />
    </AppBar>
  );
};

export default Header;
